import { Injectable } from '@angular/core';
import {
  Auth,
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
  user,
  UserCredential,
} from '@angular/fire/auth';
import { Router } from '@angular/router';
import { jwtDecode, JwtPayload } from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  user$ = user(this.auth);

  constructor(
    private router: Router,
    private auth: Auth,
  ) {}

  createUserWithEmailAndPassword(
    email: string,
    password: string,
  ): Promise<UserCredential> {
    return createUserWithEmailAndPassword(this.auth, email, password);
  }

  signOut(): Promise<boolean> {
    return signOut(this.auth).then(() => this.router.navigate(['/']));
  }

  signInWithEmailAndPassword(
    email: string,
    password: string,
  ): Promise<boolean> {
    return signInWithEmailAndPassword(this.auth, email, password).then(() =>
      this.router.navigate(['/']),
    );
  }

  async signInWithGoogle(): Promise<UserCredential> {
    const provider = await new GoogleAuthProvider();
    return signInWithPopup(this.auth, provider);
  }

  sendPasswordResetEmail(email: string): Promise<void> {
    return sendPasswordResetEmail(this.auth, email);
  }

  decodeToken(token: string): JwtPayload {
    return jwtDecode(token);
  }

  isTokenExpired(token: string): boolean {
    const decodedToken = this.decodeToken(token);

    return Boolean(decodedToken.exp && decodedToken.exp * 1000 < Date.now());
  }
}
